import ListOfNodes from './ListOfNodes.component';

export default ListOfNodes;
